/** Mapiranje paketa 1–5 za superadmin prikaz (usklađeno sa serverom). */
export const PACKAGE_LABEL_SR = {
  1: 'Besplatni',
  2: 'Starter',
  3: 'Standardni',
  4: 'Biznis',
  5: 'Premium',
};

export const PACKAGE_BADGE_CLASS = {
  1: 'bg-gray-600 text-gray-300',
  2: 'bg-slate-600 text-white',
  3: 'bg-blue-600 text-white',
  4: 'bg-purple-600 text-white',
  5: 'bg-amber-600 text-white',
};

export function resolveCompanyPackageNumber(company) {
  const n = Number(company?.package);
  if (Number.isFinite(n) && n >= 1 && n <= 5) return n;
  const legacy = String(company?.subscriptionPackage || 'free').toLowerCase();
  if (legacy === 'premium') return 5;
  if (legacy === 'business') return 4;
  if (legacy === 'standard') return 3;
  if (legacy === 'starter') return 2;
  return 1;
}

export function packageLabelSr(company) {
  return company?.billing?.packageLabelSr
    || PACKAGE_LABEL_SR[resolveCompanyPackageNumber(company)]
    || 'Besplatni';
}

export function packageBadgeClass(company) {
  return PACKAGE_BADGE_CLASS[resolveCompanyPackageNumber(company)] || PACKAGE_BADGE_CLASS[1];
}
